import swal from "sweetalert2";
import {
  getMembers,
  getMemberByID,
  createMember,
  editMember,
  deleteMember,
  checkMember,
} from "@/plugins/api.js";

const defaultState = () => ({
  members: [],
  user: {},
  accountFlag:"",
});
const state = defaultState();

const actions = {
  async getUserList(context, user) {
    await getMembers(user)
      .then(function(response) {
        context.commit("setMember", response.data.result.data);
      })
      .catch(function() {
        swal.fire({
          title: "Oops...",
          text: "網路連線異常，請確認網路連線後再嘗試",
          icon: "error",
          width: "20rem",
        });
      });
  },
  async getUserByID(context, user) {
    await getMemberByID(user);
  },
  async getUserByToken(context, user) {
    await getMembers(user)
      .then(function(response) {
        context.commit("setUser", response.data.result.data[0]);
      })
      .catch(function() {
        swal.fire({
          title: "Oops...",
          text: "網路連線異常，請確認網路連線後再嘗試",
          icon: "error",
          width: "20rem",
        });
      });
  },
  async createUser(context, user) {
    await createMember(user).then((response) => {
      if (response.data.response.status == "passed") {
        context.commit("addMember", response.data.result.data);
      } else {
        swal.fire({
          title: "Oops...",
          text: response.data.response.msg,
          icon: "error",
          width: "20rem",
        });
      }
    });
  },
  async editUser(context, user) {
    await editMember(user).then((response) => {
      let userData = response.data.result.data;
      userData["index"] = user.index;
      context.commit("setMemberByIndex", userData);
      if (response.data.response.status != "passed") {
        swal.fire({
          title: "Oops...",
          text: response.data.response.msg,
          icon: "error",
          width: "20rem",
        });
      } else {
        swal.fire({
          position: "top",
          icon: "success",
          title: "已成功被修改",
          showConfirmButton: false,
          timer: 1500,
        });
      }
      return response.data.result.data;
    });
  },
  async deleteUser(context, user) {
    await deleteMember(user);
  },
  async checkAccount(context, user) {
    await checkMember(user).then((response) => {
      context.commit("setCheckAccountFlag",response.data.result.data);
    });
  },
};

const mutations = {
  addMember(state, member) {
    state.members.push(member);
  },
  setUser(state, user) {
    state.user = user;
  },
  setMember(state, Member) {
    state.members = Member;
  },
  setMemberByIndex(state, Member) {
    console.log(state);
    state.members[Member.index] = Member;
  },
  setCheckAccountFlag(state, flag){
    state.accountFlag = flag
  }
};

const getters = {
  getMembers: function(state) {
    return state.members;
  },
  getUser: function(state) {
    return state.user;
  },
  getAccountFlag:function(state){
    return state.accountFlag;
  }
};

export default { state, actions, mutations, getters };
